import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
//import Coming from '../views/Coming.vue'

Vue.use(VueRouter)

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

const routes = [
  {
    path: '/:lang?',
    name: 'Homepage',
    component: () => import('../views/Index.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/index',
    name: 'Index',
    component: () => import('../views/Index.vue')
  },
  {
    path: '/subpage',
    name: 'Subpage',
    component: () => import('../views/SubPage.vue')
  },
  {
    path: '/product/:id/:name',
    name: 'Product',
    component: () => import('../views/Product.vue')
  },
  {
    path: '/:lang/product/:id/:name',
    name: 'Product',
    component: () => import('../views/Product.vue')
  },
  {
    path: '/page/:name',
    name: 'Page',
    component: () => import('../views/Page.vue')
  },
  {
    path: '/:lang/page/:name',
    name: 'Page',
    component: () => import('../views/Page.vue')
  },
  {
    path: '/company/profile',
    name: 'Company',
    component: () => import('../views/Company.vue')
  },
  {
    path: '/:lang/company/profile',
    name: 'Company',
    component: () => import('../views/Company.vue')
  },
  {
    path: '/contact-us/submit',
    name: 'ContactUs/submit',
    component: () => import('../views/Contactus.vue')
  },
  {
    path: '/:lang/contact-us/submit',
    name: 'ContactUs',
    component: () => import('../views/Contactus.vue')
  },
  {
    path: '/:lang/good-governance',
    name: 'GoodGovernance',
    component: () => import('../views/GoodGovernance.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
})

export default router
